import { atom } from "recoil";
export const prevTokenState = atom({
    key: "prevTokenState", // unique ID (with respect to other atoms/selectors)
    default: false, // default value (aka initial value)
});
